import { render } from "./HeaderOwner.vue?vue&type=template&id=552f8a50"
import script from "./HeaderOwner.vue?vue&type=script&lang=ts"
export * from "./HeaderOwner.vue?vue&type=script&lang=ts"
script.render = render

export default script